<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import List from "../../../../components/list";
import { propertyService } from "../../../../services/managements/propertyservice/property.service";
import { openCreditService } from "../../../../services/managements/propertyservice/opencredit.service";

// import { paymentMethodService } from "../../../../services/managements/customers/paymentmethod.service";
import i18n from "../../../../i18n";
import Loading from "@/components/c-loading";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Open Credit",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    Button,
    Input,
    Area,
    // Search,
    List
  },
  data() {
    return {
      dropdownSelection: {},
   
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Open Credit",
      breadCrumb: {},

      openCreditData: {},
      propertyData: {},

      dataCustomerId: 0,
      dataPropertyId: 0,
      dataCreditDate: this.$moment().clone().format('YYYY-MM-DD'),
      dataCashAmount: 0,
      dataBankAmount: 0,
      dataChequeAmount: 0,
      dataNotation: '',
      dataCreatedBy: JSON.parse(localStorage.getItem('user'))


    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.dataPropertyId = this.$route.params.id
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);     
    }
  },
 
  methods: {
    loadingData: function(id, param = '?page=0') {
      this.fetchingStats = true;
      param = `?clause={"clause":[{"conjuction":"and","mg_property_open_credits.property_id":{"value":${id}}}]}`;
      openCreditService.getList(param)
        .then(response => {
          if(id != 0){
            this.openCreditData = response;
            // this.paymentMethodData = response.data.id;
          }
        // this.loadPaymentMethod();
        this.loadPropertyService(id);

        });
    },

    loadPropertyService: function(id){
      propertyService.getOne(id)
        .then(response => {
          if(id != 0){
            this.propertyData = response.data;
          }
        });
    },

    // loadPaymentMethod: function() {
    //    paymentMethodService.getList()
    //     .then(response => {
    //         this.paymentMethodData = {data: response.data};
    //     });
    // },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {
          this.dataPaymentMethod = 0;
          this.dataAmount = 0;
          this.dataNotation = '';
        }
      });
    
    },
    submitSave: function() {
      
      this.tryingToSubmit = true;

      let dataSubmit = {
        property_id: this.dataPropertyId,
        credit_date: this.dataCreditDate,
        cash_amount: this.dataCashAmount,
        bank_amount: this.dataBankAmount,
        cheque_amount: this.dataChequeAmount,
        notation: this.dataNotation,
        created_by: this.dataCreatedBy.id
      };

      // check validation 
      if(!this.dataCashAmount){
        this.tryingToSubmit = false;
        return false
      }

        openCreditService.insert(dataSubmit)
         .then(response => {
           this.tryingToSubmit = false;
          
           if(response.status == 200) {
              this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              confirmButtonColor: "#34c38f",
              confirmButtonText: i18n.t('general.ok'),
            }).then(result => {
              if (result.value) {
                this.loadingData(this.dataPropertyId);
              } 
            });
           }else{
             console.log(dataSubmit)

           }
          
        });
    
    },


    clearForm: function() {

      this.dataProperty = 0;

    },

    formatCurrency(value) {
      if(value == 0 ){
        return '$0.00';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },

  },
};
</script>

<template>
  <Layout>
    <div>
      <PageHeader :items="[{
        text: $t('customer.text'),
        href: '/manage/customer',
      }, {
        text: 'Open Credit',
        active: true
      }]" :title="'Open Credit'" />
    </div>
    

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              
            <div class="row">
              <div class="col-sm-3 border py-3 me-1">
                <div class="row">
                  <div class="col">
                    <p class="khb"><u>បន្ថែម Open Credit</u></p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <Input 
                      :type="'date'"
                      :id="'deposit_date'"
                      v-model="dataCreditDate"
                      :require="true"
                      :label="'manage.customer-deposit.date'"  />
                  
                  </div>
                   <div class="col-md-12">
                    <Input 
                      :type="'number'"
                      :id="'cash_amount'"
                      v-model="dataCashAmount"
                      :require="true"
                      :label="'general.cash'"  />
                  </div>
                  <!-- <div class="col-md-12">
                    <Input 
                      :type="'number'"
                      :id="'bank_amount'"
                      v-model="dataBankAmount"
                      :require="true"
                      :label="'payment.bank_account'"  />
                  </div>
                  <div class="col-sm-12">
                         <Input 
                          :type="'text'"
                          :id="'cheque_amount'"
                          v-model="dataChequeAmount"
                          :last="'$'"
                          :label="'manage.cheque'"
                        />
                      </div> -->
                  <div class="col-sm-12">
                    <Area 
                      :rows="7"
                      :id="'notation'"
                      v-model="dataNotation"
                      :label="'income.notation'"  />
                  </div>
                </div>
                <br>
                <div class="row">
                  <div class="col-lg-12">

                    <div inline class="row gy-2 gx-3 align-items-end">
                      <div class="col-sm-auto">
                        <Button v-bind:icon="'bx bx-x-circle'" 
                          v-bind:buttonType="'button'"
                          v-bind:variant="'danger'"
                          @click="submitCancel()"
                          v-bind:title="$t('general.cancel')"  />
                      </div>
                      <div class="col-sm-auto">
                        <Button v-bind:icon="'bx bx-save bx-tada'" 
                          v-bind:buttonType="'button'"
                          @click="submitSave()"
                          v-bind:requesting="tryingToSubmit"
                          v-bind:title="$t('general.save')"  />
                      </div>
                    </div>
      
                  </div>
                </div>
              </div>

              <div class="col-sm border py-3">
                <div class="row">
                  <div class="col">
                     <p class="khb text-start"><u>{{$t('manage.customer-deposit.deposit-history')}}</u></p>
                  </div>
                  <div class="col">
                    <p class="khb text-end text-danger">{{$t('manage.customer-deposit.current-amount')}}: {{formatCurrency(this.propertyData.open_credit_amount)}}</p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <List v-bind:dataList="openCreditData" 
                      v-bind:updating="fetchingStats" 
                      v-bind:navigate="pageNavigate"
                      v-bind:formats="[{name: 'amount', type: 'currency'}, {name: 'deposit_date', type: 'date'}]"
                      v-bind:fields="[ 
                        `credit_date: ${$t('manage.customer-deposit.date')}`,
                        `amount: ${$t('manage.customer-deposit.amount')}`,
                        `notation: ${$t('payment.notation')}`,
                      ]"
                      v-bind:filter="{}"
                    />      
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </b-form> 
  </Layout>
</template>